<template>
<div class="chapter">
<div class="inner_page">
<div class="epigraphPage" id="epi" style="margin-left:    5%;">
<a id="page11">
<div class="epigraph">
<p class="epigraphText" style="text-indent: -5%; margin-left: 5%;"><em class="italic">Trickle drops! my blue veins leaving!</em></p>
<p class="epigraphText" style="text-indent: -5%; margin-left: 5%;"><em class="italic">O drops of me! trickle, slow drops,</em></p>
<p class="epigraphText" style="text-indent: -5%; margin-left: 5%;"><em class="italic">Candid from me falling, drip, bleeding drops,</em></p>
<p class="epigraphText" style="text-indent: -5%; margin-left: 5%;"><em class="italic">From wounds made to free you whence you were prison’d,</em></p>
<p class="epigraphText" style="text-indent: -5%; margin-left: 5%;"><em class="italic">From my face, from my forehead and lips,</em></p>
<p class="epigraphText" style="text-indent: -5%; margin-left: 5%;"><em class="italic">From my breast, from within where I was conceal’d, press forth red drops, confession drops,</em></p>
<p class="epigraphText" style="text-indent: -5%; margin-left: 5%;"><em class="italic">Stain every page, stain every song I sing, every word I say, bloody drops,</em></p>
<p class="epigraphText" style="text-indent: -5%; margin-left: 5%;"><em class="italic">Let me know your scarlet heart, let them glisten,</em></p>
<p class="epigraphText" style="text-indent: -5%; margin-left: 5%;"><em class="italic">Saturate them with yourself all ashamed and wet,</em></p>
<p class="epigraphText" style="text-indent: -5%; margin-left: 5%;"><em class="italic">Glow upon all I have written or shall write, bleeding drops,</em></p>
<p class="epigraphText" style="text-indent: -5%; margin-left: 5%;"><em class="italic">Let it all be seen in your light, blushing drops.</em></p>
<p class="epigraphSource" style="text-indent: 0%; margin-left: 0%;">—Walt Whitman, <em class="italic">Leaves of Grass</em></p>
</div>
</a><a id="page12">
</a><a id="page13">
</a><a id="page14">
</a></div>
<a id="page14">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780312371111_epi.vue?5fe454e6